import { gql } from "@apollo/client";

export const CREATE_RATING = gql`
  mutation CreateRating($input: CreateRatingInput!) {
    createRating(input: $input) {
      result
    }
  }
`;
